import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// import { AlertController, ToastController, Events } from 'ionic-angular';

// import * as markdownpdf from 'markdown-pdf';

import { DateTimeUtil, DateIdUtil } from '@ngcore/core';
import { AppUser } from '@ngcore/base';


@Injectable({
  providedIn : 'root'
})
export class CommonPDFxService {

  constructor(
    // private alertCtrl: AlertController,
    // private toastCtrl: ToastController,
    // private events: Events,
  ) {
    // console.log('Hello CommonMarkService Provider');

  }

  // tbd:
  // ...

}
